module.exports = "<div class=\"row\"><div class=\"col-sm-4 text-center\"><div class=\"cell\"><h3>{{reviews | number}} Reviews</h3></div></div></div>"